export const FLU_REGIONS = [
    {province: '上海市', city: '上海市', label: '上海市', hospitals: ['凌桥社区卫生服务中心', '莘庄社区卫生服务中心', '新泾社区卫生服务中心', '花木社区卫生服务中心', '上钢社区卫生服务中心', '北蔡社区卫生服务中心']},
    {province: '浙江省', city: '嘉兴市', label: '浙江省 嘉兴市', hospitals: ['魏塘街道社区卫生服务中心', '西塘镇卫生院', '凤桥镇中心卫生院', '南湖街道社区卫生服务中心', '东栅街道社区卫生服务中心']},
    {province: '浙江省', city: '湖州市', label: '浙江省 湖州市', hospitals: []},
    {province: '湖北省', city: '武汉市', label: '武汉市', hospitals: []},
    {province: '青海省', city: '', label: '青海省', hospitals: ['城关社区卫生服务中心', '矿山社区卫生服务中心', '解南社区', '田家寨']},
];
